import { Component, OnInit } from '@angular/core';
import { ApiServiceService } from '../../services/common/api-service.service';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
@Component({
  selector: 'app-support',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.scss']
})
export class SupportComponent implements OnInit {
  profileId = localStorage.getItem('profileId') || '';

  subject = '';
  category = '';
  message = '';
  screenshotBase64: string | null = null;
  screenshotFileName = '';

  submitting = false;
  submittedTicketId: string | null = null;
  errorMsg = '';

  categories = [
    { value: 'Payment', icon: 'payments', label: 'Payment' },
    { value: 'Profile', icon: 'manage_accounts', label: 'Profile' },
    { value: 'Verification', icon: 'verified_user', label: 'Verification' },
    { value: 'Technical Issue', icon: 'build', label: 'Technical Issue' },
    { value: 'Broker', icon: 'handshake', label: 'Broker' },
    { value: 'Other', icon: 'help', label: 'Other' }
  ];

  constructor(private apiService: ApiServiceService, private router: Router,private location: Location) {}

  ngOnInit(): void {}

goBack(): void {
  this.location.back();
}

  onFileChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (!input.files || !input.files[0]) return;
    const file = input.files[0];
    if (!file.type.startsWith('image/')) {
      this.errorMsg = 'Please attach a valid image file.';
      return;
    }
    if (file.size > 5 * 1024 * 1024) {
      this.errorMsg = 'Screenshot must be under 5 MB.';
      return;
    }
    this.screenshotFileName = file.name;
    const reader = new FileReader();
    reader.onload = (e: any) => {
      this.screenshotBase64 = e.target.result;
    };
    reader.readAsDataURL(file);
  }

  removeScreenshot(): void {
    this.screenshotBase64 = null;
    this.screenshotFileName = '';
  }

  canSubmit(): boolean {
    return !!this.subject.trim() && !!this.category && !!this.message.trim() && !!this.profileId;
  }

  submitTicket(): void {
    this.errorMsg = '';
    if (!this.canSubmit()) {
      this.errorMsg = 'Please fill in all required fields.';
      return;
    }
    this.submitting = true;
    this.apiService.createSupportTicket({
      profileId: this.profileId,
      subject: this.subject.trim(),
      category: this.category,
      message: this.message.trim(),
      screenshot_url: this.screenshotBase64 || null
    }).subscribe({
      next: (res) => {
        this.submitting = false;
        if (res.status === 'success') {
          this.submittedTicketId = res.data.ticket_id;
        } else {
          this.errorMsg = res.message || 'Failed to create ticket.';
        }
      },
      error: (err) => {
        this.submitting = false;
        this.errorMsg = err.error?.message || 'Something went wrong. Please try again.';
      }
    });
  }

  goToMyTickets(): void {
    this.router.navigate(['/my-tickets']);
  }

  resetForm(): void {
    this.subject = '';
    this.category = '';
    this.message = '';
    this.screenshotBase64 = null;
    this.screenshotFileName = '';
    this.submittedTicketId = null;
    this.errorMsg = '';
  }
}
